module.exports = __webpack_public_path__ + "static/media/Pranath.27ca12b2.jpeg";